<template>
	<div>
				<div class="MarkerPopup-contents">
					<h3>
						<a target="_blank" :href="`https://regio.gripp.com/d/company/edit/${data.id}`">
							{{ fullname }}
						</a>
					</h3>
					<div class="MarkerPopup-address" v-if="data.visitingaddress_street">
						<div>{{ data.visitingaddress_street }} {{ data.visitingaddress_streetnumber }}</div>
						<div v-if="data.visitingaddress_zipcode">{{ data.visitingaddress_zipcode }}</div>
						<div v-if="data.visitingaddress_city">{{ data.visitingaddress_city }}</div>
						<div class="edit-email">{{ data.email }} <button @click="onChangeEmailClick"><Edit2Icon></Edit2Icon></button></div>
					</div>
					<div class="MarkerPopup-appointment" v-if="additional != null">
						<div class="appointment-item">
							<span>Leadkanaal:</span>
							<span>{{ additional.customfield_leadkanaal ? additional.customfield_leadkanaal : 'Onbekend' }}</span>
						</div>
						<div class="appointment-item" v-if="!empty(additional.customfield_dmbron)">
							<span>Bron:</span>
							<span>{{ additional.customfield_dmbron ? additional.customfield_dmbron : 'Onbekend' }}</span>
						</div>
						<div class="appointment-item" v-if="additional.customfield_leadkanaal === 'KMK' || additional.customfield_leadkanaal === 'ThermoTrees'">
							<span>KMK:</span>
							<span>{{ additional.customfield_kmkmedewerker }}</span>
						</div>
						<div class="appointment-item" v-if="additional.kmkReferer != null && additional.kmkReferer.id">
							<span>Aangebracht door:</span>
							<span>
								<a target="_blank" :href="`https://regio.gripp.com/d/company/edit/${additional.kmkReferer.id}`">
									{{ additional.kmkReferer.companyname }}
								</a>
							</span>
						</div>
						<div class="appointment-item">
							<span>Aangemaakt op:</span>
							<span>{{ parseDate(additional.createdon.substring(0, 10)) }}</span>
						</div>
					</div>
					<template v-if="additional != null">
						<div class="MarkerPopup-appointment" v-for="project in additional.projects">
							<div class="appointment-item">
								<span><b>{{ project.name }}</b></span>
								<span>{{ project.number }}</span>
							</div>
							<div class="appointment-item">
								<span>Uitgevoerd op</span>
								<span>{{ !empty(project.deliverydate) ? parseDate(project.deliverydate.substring(0, 10)) : 'onbekend' }}</span>
							</div>
						</div>
					</template>
				</div>
				<a class="MarkerPopup-phone" :href="'tel:' + phoneNumber" v-if="phoneNumber">
					<PhoneIcon/>
					{{ phoneNumber }}
				</a>
				<div class="MarkerPopup-lastupdated" v-if="additional != null && !empty(additional.customfield_laatstgebeldmarketing)">
					{{ additional.customfield_laatstgebeldmarketing }}
				</div>
				<div class="MarkerPopup-lastTimeline" v-if="data.lastTimeline != null && data.lastTimeline.message">
					{{ data.lastTimeline.message }}
				</div>
				<div class="MarkerPopup-tags" v-if="data.tags.length > 0">
					<span v-for="tag in data.tags" :key="tag.name" class="MarkerPopup-tag">{{ tag.name }}</span>
				</div>
				<div class="MarkerPopup-actions">
					<Button @click="onClickActionReview($event,
					'review');">Review
					</Button>
					<Button @click="onClickAction($event,
					'kmk');">Thermotrees
					</Button>
					<Button
						@click="onClickCreateNote('Marketing');">
						Notitie...
					</Button>
					<Button @click="onClickAction($event,
					'gebeld');">Gebeld
					</Button>
					<Button @click="onClickAction($event,
					'voltooid');">Marketing voltooid
					</Button>
					<Button v-if="additional != null && additional.projects.length === 1" @click="onClickSupport(additional.projects[0].id)">
						Support
					</Button>
					<DropdownButton v-if="additional != null && additional.projects.length > 1">
						<template v-slot:button>Support</template>
						<Button v-for="project in additional.projects" @click="onClickSupport(project.id)" :key="'project' + project.id">{{ project.name }}</Button>
					</DropdownButton>
				</div>
	</div>
</template>

<script>
import CreateSupportTicketModal from "@/components/CreateSupportTicketModal.vue";
import { mapState, mapActions } from 'vuex';
import Button from '@/components/Button';
import DropdownButton from '@/components/DropdownButton';
import CreateNote from '@/components/CreateNote';
import Collapsible from '@/components/Collapsible';
import { PhoneIcon, Edit2Icon } from 'vue-feather-icons';
import { calculatePlanningAppointmentEndTime, parseDate } from "@/utils";
import ChangeEmail from "../mapModal/ChangeEmail.vue";

export default {
	components: {
		Button,
		DropdownButton,
		PhoneIcon,
		Edit2Icon,
		Collapsible,
	},

	props: {
		data: Object
	},

	data() {
		return {
			additional: null,
		};
	},

	beforeMount() {
		this.fetchAdditionalMarkerInfo({id: this.data.id}).then(data => {
			this.additional = data;
		});
	},

	computed: {
		...mapState('map', {
			mapType: 'mapType',
			marketingReviewPlatform: 'marketingReviewPlatform'
		}),
		phoneNumber() {
			if (!this.empty(this.data.phone)) {
				return this.data.phone;
			} else if (!this.empty(this.data.mobile)) {
				return this.data.mobile
			} else {
				return null;
			}
		},

		fullname() {
			const salutations = {
				1: 'Dhr.',
				2: 'Mevr.',
				3: 'Dhr/Mevr.',
			};

			let name = [];
			if (this.data.salutation !== '') name.push(salutations[parseInt(this.data.salutation)]);
			if (this.data.initials !== '') name.push(this.data.initials);
			if (this.data.infix !== '') name.push(this.data.infix);
			if (this.data.lastname !== '') name.push(this.data.lastname);
			if (name.length === 0) name.push(this.data.companyname);

			return name.join(' ');
		},
	},

	methods: {
		...mapActions({
			performAction: 'map/performAction',
			performActionReview: 'map/performActionReview',
			fetchAdditionalMarkerInfo: 'map/fetchAdditionalMarkerInfo',
			getProjectById: "projects/getProjectById"
		}),

		onClickCreateNote(type) {
			this.$modal.show(CreateNote, {data: this.data, type: type}, {
				classes: 'modal',
				adaptive: true,
				scrollable: true,
				width: '100%',
				height: 'auto',
				maxWidth: 600,
			});
		},

		onClickAction(button, type) {
			button.disable();

			this.performAction({
				company_id: this.data.id,
				user_id: this.$store.state.map.viewingUserId,
				type: type,
			}).then(result => {
				button.enable();
				if(type === 'review') {
					this.showReviewToast();
				} else if(type === 'kmk') {
					this.showKmkToast();
				}
				this.$events.emit('map/closePopup');
			}).catch((error) => {
				console.log('error', error);
				console.log('error: possible error dupicated tag');
				this.$notify({
					group: 'app',
					title: 'Error',
					type: 'error',
					text: `Er is een fout opgetreden: ${error}`,
				});
				button.enable();
			});
		},

		onClickActionReview(button, type) {
			button.disable();

			this.performActionReview({
				company_id: this.data.id,
				user_id: this.$store.state.map.viewingUserId,
				type: type,
				marketing_review_platform: this.marketingReviewPlatform
			}).then(result => {
				button.enable();
				if(type === 'review') {
					this.showReviewToast();
				} else if(type === 'kmk') {
					this.showKmkToast();
				}
				this.$events.emit('map/closePopup');
			}).catch((error) => {
				console.log('error', error);
				console.log('error: possible error dupicated tag');
				this.$notify({
					group: 'app',
					title: 'Error',
					type: 'error',
					text: `Er is een fout opgetreden: ${error}`,
				});
				button.enable();
			});
		},


		showReviewToast() {
			this.$notify({
				group: 'app',
				title: 'Review aanvraag',
				type: 'success',
				text: `Review aanvraag verstuurd`,
			});
		},
		showKmkToast() {
			this.$notify({
				group: 'app',
				title: 'Thermotrees aanvraag',
				type: 'success',
				text: `Thermotrees aanvraag verstuurd`,
			});
		},
		onClickSupport(projectId) {
			this.getProjectById({id: projectId}).then(project => {
				this.$modal.show(CreateSupportTicketModal, {
					project: project
				}, {
					classes: "modal",
					adaptive: true,
					scrollable: true,
					width: "100%",
					height: "auto",
					maxWidth: 1200
				});
			});
		},

		onChangeEmailClick() {
			this.$modal.show(ChangeEmail, {company: this.data}, {
				classes: 'modal',
				adaptive: true,
				scrollable: true,
				width: '100%',
				height: 'auto',
				maxWidth: 600,
			});
		},

		parseDate(date) {
			return parseDate(date);
		},

		calculatePlanningAppointmentEndTime(time, durationHours) {
			return calculatePlanningAppointmentEndTime(time, durationHours);
		},

		empty(value) {
			return value == null || (typeof value === "string" && value.trim() === "");
		}
	}
};
</script>

<style lang="scss" scoped>
.MarkerPopup-address, .MarkerPopup-appointment {
	border-bottom: 1px solid #eee;
	padding-bottom: 20px;
	margin-bottom: 0.5em;
}

.MarkerPopup-appointment:not(:first-child) {
	margin-top: 1em;
}

.appointment-item {
	display: flex;
	justify-content: space-between;
}

.edit-email {
	display: flex;

	button {
		height: 1.17rem;
		width: 1.17rem;
		margin: 0 0 0 4px;
		border: none;
		background: transparent;
		padding: 2px;
		svg {
			color: #35a5a4;
			max-height: 100%;
			max-width: 100%;
		}
	}
}
</style>
